import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import { TemplatePreviewableItemsV } from "@/types/templates";

export async function fetchTemplatePreviewableItems({
  id,
  search = ""
}: {
  id: number;
  search?: string;
  overrideAjaxUrl?: string;
}) {
  return makeWordPressAjaxRequest({
    action: "breakdance_get_template_previewable_items_with_search",
    dataToPost: {
      search,
      id
    },
    decoder: TemplatePreviewableItemsV,
    resultKey: "data"
  });
}
